export const TRIAL_APPLY_INIT_STEPS = ['legal-age', 'english', 'email'] as const

export type TrialApplyInitStep = (typeof TRIAL_APPLY_INIT_STEPS)[number]

export type TrialApplyFlowInitStep = {
  stepId: TrialApplyInitStep
}

// add components similar to apply-survey later
export const TrialApplyFlowInitSteps: TrialApplyFlowInitStep[] = [
  {
    stepId: 'legal-age',
  },
  {
    stepId: 'english',
  },
  {
    stepId: 'email',
  },
]
